import {
    renderAccount,
    renderAircraft,
    renderCloudAhoy,
    renderBilling,
    renderCustomContent,
    renderDataDownloads,
    renderDirectory,
    renderDispatch,
    renderEnterpriseDocuments,
    renderDocs,
    renderFleetTracking,
    renderFlights,
    renderFSP,
    renderHoneywellForge,
    renderImagery,
    renderJetFuelX,
    renderLogbook,
    renderInsurance,
    renderMap,
    renderOrg,
    renderPeople,
    renderReservoir,
    renderRoster,
    renderTrackLogs,
    renderTripAssistant,
    renderOrgSettings,
    renderSmartGroups,
    renderDefaultRecap,
    renderChecklist,
    renderFlightScheduler,
    renderAirportDirectory,
    renderFleet,
    renderSafetyManagementSystems,
    renderJra,
} from 'ff/common/components/FFMenuV2/MenuItems';
import renderDivider from 'ff/common/components/FFMenuV2/MenuItems/Divider';
import fillSpace from 'ff/common/components/FFMenuV2/MenuItems/FillSpace';
import { RenderMenuParams } from 'ff/common/components/FFMenuV2/RenderMenuParams';
import {
    hasSmsLicense,
    hasTrackingLicense,
    hasTrackingRole,
} from 'ff/common/system';

export default function RenderDefaultMenu(params: RenderMenuParams) {
    return [
        renderDefaultRecap,
        params?.currentUser?.dispatch_tools ||
        params?.currentUser?.isFF_FspAdmin
            ? renderDispatch
            : null,
        params?.currentUser?.jeppesen_runway_analysis ? renderJra : null,
        // show Tracking if the org has a Tracking license AND the user has Tracking access
        // OR if the org does not have Tracking but does have Dispatch -- will redirect to ad to purchase Tracking
        params?.currentUser &&
        ((hasTrackingLicense(params?.currentUser) &&
            hasTrackingRole(params?.currentUser)) ||
            (!hasTrackingLicense(params?.currentUser) &&
                params?.currentUser?.dispatch_tools &&
                !params?.currentUser?.hasDispatchLowca))
            ? renderFleetTracking
            : null,
        renderFlights,
        renderMap,
        renderImagery,
        renderDocs,
        renderCustomContent,
        renderAircraft,
        renderFleet,
        renderSafetyManagementSystems,
        renderFlightScheduler,
        renderAirportDirectory,
        renderLogbook,
        renderInsurance,
        renderTrackLogs,
        renderCloudAhoy,
        renderPeople,
        renderReservoir,
        renderDirectory,
        renderTripAssistant,
        renderHoneywellForge,
        renderRoster,
        renderDataDownloads,
        renderDivider,
        renderFSP,
        renderOrg,
        renderOrgSettings,
        renderSmartGroups,
        renderBilling,
        renderEnterpriseDocuments,
        renderJetFuelX,
        renderChecklist,
        renderDivider,
        renderAccount,
        fillSpace.bind(null, { flex: '1' }),
    ];
}
